import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csoperator(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };

return(
      <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free PHP Operator Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php Operator tutorial for beginners.Operators in Php are used special symbols which perform any type of operations.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php spread operator,php arrow operator,php operator precedence,php operators,programming language tutorial for begineers" />
 <link rel="canonical" href="https://www.codeexampler.com/php-operator" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php Operator</h1>
    <div className="first">
        <a href="/php-comments">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">An Operator in Php</h2>
    <p className="mt-4 para">Operators in Php use special symbols that perform any operation.<br/>
or<br/>
The Php operator is a special symbol that is using in the expression.
</p>


<h2 className="headings">An operator in Php Syntax code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-6">106</span>
            <span className="qwerty-3"> / </span>
            <span className="qwerty-6">8</span>
            <span className="qwerty-3"> % </span>
            <span className="qwerty-6">40</span>
             {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-2">(</span>
            <span className="qwerty-5"> + </span>
            <span className="qwerty-2">- /</span>
            <span className="qwerty-5"> %</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-7"> this is an  </span>
            <span className="qwerty-4">operator</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">An Operator in Php Syntax code Example</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
          <span className="qwerty-5"> $</span>
            <span className="qwerty-6">a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-6">b </span>
            <span className="qwerty-2">+ </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-6">c </span>
            <span className="qwerty-2">- </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-6">d</span>
            <span className="qwerty-2">;</span>
             {"\n"} 
             <span className="qwerty-4"> Above in this line of code </span>
            {"\n"}  {"\n"}
          </code>
        </pre>
      </div>

      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-2">+</span>
            <span className="qwerty-5">, </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-7"> are operators means there are</span>
            <span className="qwerty-5"> Two operators </span>
            {"\n"}
            <span className="qwerty-2">a</span>
            <span className="qwerty-5">, </span>
            <span className="qwerty-2">b</span>
            <span className="qwerty-5">, </span>
            <span className="qwerty-2">c</span>
            <span className="qwerty-5">, </span>
            <span className="qwerty-2">d</span>
            <span className="qwerty-7"> are operands means there are </span>
            <span className="qwerty-5">Four operands</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">1, Arithmetic operator:</h2>
<h3 className="mt-4 mh3">+ add<br/>
-Sub<br/>
Multiply<br/>
/ division<br/>
% modules<br/>
++ increment<br/>
-- decrement<br/>
</h3>
<h2 className="mt-4 mh2">Php Operator Example</h2>

      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6"> php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">8</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">b </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">4</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">c</span>
            <span className="qwerty"> = </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-5">echo </span>
              <span className="qwerty">$</span>
                <span className="qwerty-7">c</span>
              <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">12 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="headings">Php Operator Syntax code:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5"> $</span>
            <span className="qwerty-6">C</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-2">- </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty">b</span>
            <span className="qwerty-9"> ;</span>
            {"\n"}
            <span className="qwerty-5"> $</span>
            <span className="qwerty-6">C</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-2">+ </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty">b</span>
            <span className="qwerty-9"> ;</span>
            {"\n"}
            <span className="qwerty-5"> $</span>
            <span className="qwerty-6">C</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-2">* </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty">b</span>
            <span className="qwerty-9"> ;</span>
            {"\n"}
            <span className="qwerty-5"> $</span>
            <span className="qwerty-6">C</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-2">/ </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty">b</span>
            <span className="qwerty-9"> ;</span>
            {"\n"}
            <span className="qwerty-5"> $</span>
            <span className="qwerty-6">C</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-2">% </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty">b</span>
            <span className="qwerty-9"> ;</span>
            {"\n"}
            <span className="qwerty-5"> $</span>
            <span className="qwerty-6">C</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-9"> ; </span>
            <span className="qwerty-4">or </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-2">--</span>
            <span className="qwerty-9"> ;</span>
            {"\n"}
            <span className="qwerty-5"> $</span>
            <span className="qwerty-6">C</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty">b </span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-9"> ; </span>
            <span className="qwerty-4">or </span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty">b </span>
            <span className="qwerty-2">--</span>
            <span className="qwerty-9"> ;</span>
             {"\n"}   {"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">2, Relational operator:</h2>
<h3 className="mt-4 mh3"> Greater than  <br/>
&#60;less than <br/>
&#62;=greater than or equal to<br/>
&#60;= -less than or equal to<br/>
!= - not equal to<br/>
== -equal to<br/>
</h3>

<h2 className="mt-4 mh2">Php Relational Operator Example:</h2>


<h2 className="headings">Q-If b is Greater than so print B is Print B is Greater?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-10">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty"> $</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-5">echo </span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-6">is </span>
            <span className="qwerty-7">greater</span>
            <span className="qwerty-3">");</span>
            {"\n"}
            <span className="qwerty-4">?</span>
            <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-10">b </span>
            <span className="qwerty-6">is </span>
            <span className="qwerty-7">greater</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-If a is Equal to B so print a is Equal to B?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">b </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty">if </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-5">echo </span>
              <span className="qwerty">"</span>
                <span className="qwerty-7">both are equal</span>
              <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">both equal</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">3, Logic operator:</h2>
<h3 className="mt-4 mh3">And  &#38;&#38;<br/>
Or   &#124;&#124;<br/>
Not&#33;
</h3>



<h2 className="mt-4 mh2">4, Bitwise operator:</h2>
<h3 className="mt-4 mh3">
&#62;&#62; - right shift<br/>
    &#60;&#60; - left shift<br/>
^ xor<br/>
~ B Not<br/>
</h3>

<h2 className="mt-4 mh2">5, Assignment operator:</h2>
<h3 className="mt-4 mh3">=<br/>
+=<br/>
-=<br/>
*=<br/>
/=<br/>
%=<br/>
&#47;&#47;=<br/>
**=<br/>
&#38;=<br/>
&#60;&#60;=<br/>
&#62;&#62;=<br/>
^=<br/>
</h3>

<h2 className="mt-4 mh2">6, Identifier operator in Php:</h2>


      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6"> php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">5</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty">(</span>
                <span className="qwerty">$</span>
                <span className="qwerty-7">a </span>
              <span className="qwerty-3">);</span>
              {"\n"}{"\n"}
              <span className="qwerty-10">echo </span>
            <span className="qwerty-4">"\</span>
            <span className="qwerty-3">n</span>
            <span className="qwerty-4">"</span>
            <span className="qwerty-3">; </span>
              {"\n"}{"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4"> = </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3"> * </span>
            <span className="qwerty-4">4</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty">(</span>
                <span className="qwerty">$</span>
                <span className="qwerty-7">a </span>
              <span className="qwerty-3">);</span>
              {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">5</span>
              {"\n"}
              <span className="qwerty-6">20</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">7, The conditional operator (? :) in Php:-
</h2>
<p className="mt-4 para">A conditional operator is known as a <span className="bold"> ternary operator.</span><br/>
The main point is that this Conditional operator  consists of three operands.<br/>
</p>



<h2 className="headings">Php conditional Operator Syntax code:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-6">Variable</span>
            <span className="qwerty-5"> a </span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">expression</span>
            <span className="qwerty-2">) </span>
            <span className="qwerty-5">? </span>
            <span className="qwerty">true </span>
            <span className="qwerty-2">:</span>
            <span className="qwerty-5"> false</span>
             {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">8, Unary operator:</h2>
<h3 className="mt-4 mh3">++<br/>
--
</h3>
<h2 className="headings">Php Urinary Operator Syntax code:</h2>



      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6"> php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty">(</span>
                <span className="qwerty">$</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">);</span>
              {"\n"}{"\n"}
              <span className="qwerty-10">echo </span>
            <span className="qwerty-4">"/</span>
            <span className="qwerty-3">n</span>
            <span className="qwerty-4">&#62;"</span>
            <span className="qwerty-3">; </span>
              {"\n"}{"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">++ </span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty">(</span>
                <span className="qwerty">$</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">);</span>
              {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">10</span>
              {"\n"}
              <span className="qwerty-6">11</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="headings">Q-If you add more no inside unary Php operator?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6"> php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-3">; </span>
              {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">+</span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-3">; </span>
            {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty">(</span>
                <span className="qwerty">$</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">);</span>
              {"\n"}{"\n"}
              <span className="qwerty-5">OR</span>
              {"\n"} {"\n"}
              <span className="qwerty">Error</span>
            <span className="qwerty-3">: </span>
              {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">++++</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty">(</span>
                <span className="qwerty">$</span>
                <span className="qwerty-7">a</span>
              <span className="qwerty-3">);</span>
              {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">22</span>
              {"\n"}
              <span className="qwerty-10">error</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Change position of the unary operator?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">If we use </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-6">++</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">)</span>
            {"\n"} {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">; </span>
              {"\n"}
            <span className="qwerty-5">echo </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
              <span className="qwerty-5">echo </span>
              <span className="qwerty-7">"\</span>
                <span className="qwerty">br/</span>
                <span className="qwerty-7">"</span>
              <span className="qwerty-3">;</span>
              {"\n"}{"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-6">++</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-5">echo</span>
              <span className="qwerty-3">(</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">; </span>
              {"\n"} {"\n"}   {"\n"} {"\n"}
              <span className="qwerty-3">If we use  </span>
              <span className="qwerty-4">(</span>
                <span className="qwerty-7">a</span>
                <span className="qwerty-6">++</span>
              <span className="qwerty-4">)</span>
              {"\n"}{"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-3">; </span>
              {"\n"}
            <span className="qwerty-5">echo </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
              <span className="qwerty-5">echo </span>
              <span className="qwerty-7">"\</span>
                <span className="qwerty">br</span>
                <span className="qwerty-7">"</span>
              <span className="qwerty-3">;</span>
              {"\n"}{"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty"> = </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">a</span>
            <span className="qwerty-6">++</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-5">echo</span>
              <span className="qwerty-4">(</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">b</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">20</span>
              {"\n"}
              <span className="qwerty-6">21</span>
              {"\n"}{"\n"}
              <span className="qwerty-6">20</span>
              {"\n"}
              <span className="qwerty-6">20</span>
              {"\n"}
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/php-comments">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)
}
export default Csoperator;